<script lang="ts">
	import QuoteMarker from '$lib/icons/quoteMarker.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			text: string;
			author: string;
			author_subtext: string;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div
	use:editable={content}
	class="flex flex-col gap-y-5 text-[16px]/[150%] tracking-[-.16px] text-white lg:text-[20px]/[140%] lg:tracking-[-.2px]"
>
	<QuoteMarker class="h-5 w-6" />
	<p class="">{content.text}</p>
	<div>
		<p>{content.author}</p>
		<p class="text-[14px]/[100%] tracking-[-.28px] lg:text-[14px]/[130%]">
			{content.author_subtext}
		</p>
	</div>
</div>
